<template>
  <div class="notice" :style="{'paddingTop': statusBar + 'rem'}" ref="getheigh">
    <Header title="政策文件" :back="true" left="返回" :white="true" />
    <div class="noticemain" ref="getheight">
      <ul class="list">

        <li v-for="(item, i) in noticList" :key="i" @click="gotoNotice(item.noticeId)">
          <p class="redio">
            <span></span>
          </p>
          <p class="text">
            <span class="text1">{{item.noticeTitle}}</span>
            <span class="text2">{{item.publishtime}}</span>
          </p>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "policy",
  /**
   * 初始化数据
   */
  data() {
    return {
      noticList: [],
      backormoren: true,
      statusBar: 0,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getMobileNoticList();
    console.log(window.scrollY);
  },
  updated() {
    /**
     * 页面加载完毕后Y轴置在最顶端
     * bug出现形式未知
     */
    window.scroll(0, 0);
    console.log("nextTick " + window.scrollY);
  },

  /**
   * 方法
   */
  methods: {
    /**
     * 获取首页menu数据
     */
    getMobileNoticList() {

      this.noticList.push({"noticeId":"1","noticeTitle":"海关总署 农业农村部公告2021年第15号（关于防止阿尔及利亚高致病性禽流感传入我国的公告）","noticeUrl":"xx","publishtime":"2021/02/20","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"2","noticeTitle":"海关总署公告2021年第14号（关于进口老挝屠宰用肉牛检疫卫生要求的公告）","noticeUrl":"xx","publishtime":"2021/02/10","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"3","noticeTitle":"海关总署公告2021年第13号（关于发布海南离岛旅客免税购物邮寄送达和返岛提取提货方式监管要求的公告）","noticeUrl":"xx","publishtime":"2021/02/04","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"4","noticeTitle":"海关总署公告2021年第12号（关于防止斯里兰卡牛结节性皮肤病传入我国的公告）","noticeUrl":"xx","publishtime":"2021/02/01","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"5","noticeTitle":"海关总署公告2021年第11号（关于发布《北京2022年冬奥会和冬残奥会海关通关须知》的公告）","noticeUrl":"xx","publishtime":"2021/01/28","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
/*      this.$http1
        .post("/zsdyckserver/app/notice/getNotices", {})
        .then((res) => {
          this.noticList = res.resultData;
        })
        .catch((err) => {
          if (err === 302) {
            window.console.log(err);
          }
        });
*/        
    },

    /**
     * 跳转小应用
     */
    gotoNotice(noticeId) {
      this.backormoren = false;

      this.$router.push({
        name: "policyDetail",
        query: {
          noticeId: `${noticeId}`,
        },
      });
      //     this.$router.push(val)
      // this.$tool.sessionData('#ffffff', 'true');
    },
  },
  // beforeDestroy() {
  //   if(this.backormoren){
  //     this.$tool.beforeDestroy(1);
  //   }
  // },
  components: {
    Header,
  },
};
</script>

<style scoped lang="scss">
.notice {
  width: 100%;
  background: #f7f8fa;
  .noticemain {
    overflow: auto;
    background: #fff;
    .list {
      padding-top: 12px;
      li {
        display: flex;
        margin: 0 12px;
        .redio {
          width: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 6px;
            height: 6px;
            display: block;
            background: #a0a5aa;
            border-radius: 50%;
          }
        }
        .text {
          flex: 1;
          display: flex;
          padding: 20px 0;
          border-bottom: 1px solid $lineColor;
          .text1 {
            font-size: 12px;
            line-height: 14px;
            display: block;
            color: $fontColor;
            width: 250px;
            white-space: nowrap; //强制不换行
            overflow: hidden; //自动隐藏文字
            text-overflow: ellipsis; //文字隐藏后添加省略号
            -o-text-overflow: ellipsis; //适用于opera浏览器
          }
          .text2 {
            text-align: right;
            width: 80px;
            color: #a0a5aa;
            line-height: 14px;
            display: block;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>

